import type {ImagePart} from '@Components/ai-chat-window/ai-chat-window.types';

export const MORE_OPTIONS_DROPDOWN_MODAL_PANEL_ID = 'lightbox-more-options-dropdown-modal-panel-id';

export interface GeneratedImageLightboxHeaderContentProps {
  isOpen: boolean;
  onClose: VoidFunction;
  hashedId: string;
  chatId: string;
  messageId?: string;
  canWrite: boolean;
  onReattach: (part: ImagePart, previewUrl?: string) => void;
  currentImage: ImagePart;
  currentImageSrc?: string;
  hasLayeredPoster: boolean;
}
